import React from 'react'
import './NoMatch.css'

export default () => {
  return (
    <div className='NoMatch section'>
      <div className='container'>
        <h3>Page Not Found <span role='img' aria-label='Whoops!'>😅</span></h3>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/NoMatch.js